export default __webpack_public_path__ + "static/media/calconvert_background_m2.5f883eae.jpg";